const sidebaritems = [
    {
        display_name: 'Faculty Dashboard',
        cName: 'side-text-title',
    },
    {
        display_name: 'All My Projects',
        route: './allownedprojects',
        cName: 'side-text',
    },
    {
        display_name: 'Bookmarked Members',
        route: './bookmarkedmembers',
        cName: 'side-text',
    },
    {
        display_name: 'Bookmarked Projects',
        route: './bookmarkedprojects',
        cName: 'side-text',
    },
    {
        display_name: 'Invited Members',
        route: './invitedmembers',
        cName: 'side-text',
    },
]

export default sidebaritems
